// API 기본 URL (환경변수로 관리 권장)
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

// 세션 ID 저장소
let sessionId = null;

// 세션 ID 가져오기
const getSessionId = () => {
  if (!sessionId) {
    sessionId = localStorage.getItem('kmong_session_id');
  }
  return sessionId;
};

// 세션 ID 저장
const setSessionId = (id) => {
  sessionId = id;
  if (id) {
    localStorage.setItem('kmong_session_id', id);
  } else {
    localStorage.removeItem('kmong_session_id');
  }
};

// API 요청 헬퍼 함수
const fetchAPI = async (endpoint, options = {}) => {
  const url = `${API_BASE_URL}${endpoint}`;

  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  // 세션 ID가 있으면 헤더에 추가
  const currentSessionId = getSessionId();
  if (currentSessionId) {
    headers['X-Session-Id'] = currentSessionId;
  }

  const config = {
    ...options,
    headers,
    credentials: 'include', // 쿠키 포함 (세션 관리)
  };

  try {
    const response = await fetch(url, config);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
};

// Chat API
export const chatAPI = {
  // 로그인
  login: async (email, password) => {
    const response = await fetchAPI('/login', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    });

    // 로그인 성공 시 세션 ID 저장
    if (response.success && response.sessionId) {
      setSessionId(response.sessionId);
    }

    return response;
  },

  // 로그아웃
  logout: async () => {
    const response = await fetchAPI('/logout', {
      method: 'POST',
    });

    // 로그아웃 시 세션 ID 제거
    setSessionId(null);

    return response;
  },

  // 현재 사용자 정보
  getCurrentUser: async () => {
    try {
      return await fetchAPI('/user');
    } catch (error) {
      return null; // 로그인하지 않은 경우
    }
  },

  // 모니터링 시작
  startMonitoring: async () => {
    return fetchAPI('/monitoring/start', {
      method: 'POST',
    });
  },

  // 모니터링 중지
  stopMonitoring: async () => {
    return fetchAPI('/monitoring/stop', {
      method: 'POST',
    });
  },

  // 채팅 목록 조회
  getChats: async () => {
    return fetchAPI('/chats');
  },

  // 통계 조회
  getStats: async () => {
    return fetchAPI('/stats');
  },

  // 설정 조회
  getSettings: async () => {
    return fetchAPI('/settings');
  },

  // 업데이트 확인 (폴링용)
  checkUpdates: async () => {
    return fetchAPI('/chats/updates');
  },

  // 답변 전송
  sendReply: async (chatId, message) => {
    return fetchAPI(`/chats/${chatId}/reply`, {
      method: 'POST',
      body: JSON.stringify({ message }),
    });
  },

  // AI 답변 생성
  generateResponse: async (message) => {
    return fetchAPI('/generate-response', {
      method: 'POST',
      body: JSON.stringify({ message }),
    });
  },

  // 설정 업데이트
  updateSetting: async (key, enabled) => {
    const endpoint = key === 'autoReply' 
      ? '/settings/auto-reply' 
      : '/settings/notification';
    
    return fetchAPI(endpoint, {
      method: 'POST',
      body: JSON.stringify({ enabled }),
    });
  },

  // 채팅 내역 다운로드
  exportChats: () => {
    window.location.href = `${API_BASE_URL}/chats/export`;
  },

  // 답변 승인
  approveReply: async (chatId) => {
    return fetchAPI(`/chats/${chatId}/approve`, {
      method: 'POST',
    });
  },

  // 답변 보류
  rejectReply: async (chatId) => {
    return fetchAPI(`/chats/${chatId}/reject`, {
      method: 'POST',
    });
  },

  // 보류된 채팅 목록
  getRejectedChats: async () => {
    return fetchAPI('/chats/rejected');
  },
};
